import { Component, OnInit } from '@angular/core';
import { OwlOptions } from 'ngx-owl-carousel-o';
import { JobsStore } from '../../store/jobs-store.service';
import { Subscription } from 'rxjs';
import { JobSummary } from '../../models/job-summary';

@Component({
  selector: 'jobs-carousel',
  templateUrl: './jobs-carousel.component.html',
  styleUrls: ['./jobs-carousel.component.scss']
})
export class JobsCarouselComponent implements OnInit {
  subscription: Subscription;
  latestJobs: JobSummary[];
  photoPath: string = "assets/images/avatar/12.svg";
  customOptions: OwlOptions = {
    loop: true,
    mouseDrag: false,
    touchDrag: false,
    pullDrag: false,
    dots: false,
    navSpeed: 700,
    navText: ['', ''],
    responsive: {
      0: {
        items: 1
      },
      400: {
        items: 2
      },
      740: {
        items: 3
      },
      940: {
        items: 4
      }
    },
    nav: true
  }
  constructor(private jobStore: JobsStore) { }

  ngOnInit(): void {
    this.subscription = this.jobStore.latestJobs.subscribe(resp => {
      this.latestJobs = resp;
      console.log(this.latestJobs )
    });
  }

  onFavouriteClicked(jobId: string): void {
    const foundJob = this.latestJobs.find(job => job.id == jobId);
    if(!foundJob) {
      throw new Error(`Job not found for Id ${jobId}`);
    }

    foundJob.bookmarked = !foundJob.bookmarked;
    if(foundJob.bookmarked) {
      this.jobStore.bookmarkJobInLocalStore(foundJob.id);
    } else {
      this.jobStore.unBookmarkJobInLocalStore(foundJob.id);
    }
  }

  ngOnDestroy(): void {
    if(this.subscription){
      this.subscription.unsubscribe(); 
    }
  }


}
